/** @format */

import {useState, ComponentProps} from 'react';

import {useTheme} from '@mui/material/styles';
import {Rectangle} from 'recharts';

type Props = ComponentProps<typeof Rectangle> & {
  payload?: {value: number};
};

function BarShape(props: Props) {
  const theme = useTheme();
  const {x = 0, y = 0, width = 0, height = 0, payload} = props;
  const value = payload?.value ?? 0;
  const [isHovered, setIsHovered] = useState(false);

  // Не рисуем бар, если значение равно нулю
  if (value === 0) {
    return <rect x={0} y={0} width={0} height={0} fill='none' />;
  }

  const defaultColor =
    value >= 0
      ? isHovered ? theme.palette.semantic_dark!.bad.hover : theme.palette.semantic_dark!.bad.main
      : isHovered ? theme.palette.semantic_dark!.good.hover : theme.palette.semantic_dark!.good.main;

  const normalizedX = width < 0 ? x + width : x;
  const normalizedWidth = Math.abs(width);

  const radius = 6;
  const isPositive = value >= 0;

  // Для положительных - закругляем правые углы, для отрицательных - левые
  const path = isPositive
    ? `M ${normalizedX} ${y}
                   L ${normalizedX + normalizedWidth - radius} ${y}
                   Q ${normalizedX + normalizedWidth} ${y} ${normalizedX + normalizedWidth} ${y + radius}
                   L ${normalizedX + normalizedWidth} ${y + height - radius}
                   Q ${normalizedX + normalizedWidth} ${y + height} ${normalizedX + normalizedWidth - radius} ${y + height}
                   L ${normalizedX} ${y + height}
                   Z`
    : `M ${normalizedX + radius} ${y}
                   L ${normalizedX + normalizedWidth} ${y}
                   L ${normalizedX + normalizedWidth} ${y + height}
                   L ${normalizedX + radius} ${y + height}
                   Q ${normalizedX} ${y + height} ${normalizedX} ${y + height - radius}
                   L ${normalizedX} ${y + radius}
                   Q ${normalizedX} ${y} ${normalizedX + radius} ${y}
                   Z`;

  return (
    <g>
      <path
        d={path}
        fill={defaultColor}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{cursor: 'pointer'}}
      />
    </g>
  );
}

export default BarShape;

